(ns ui.components.toast.view
  (:require
   [oops.core :as oops]
   [reagent.core :as r]
   ["react-hot-toast" :default Toast :refer (Toaster)]))

(def react-hot-toast-toaster (r/adapt-react-class Toaster))

(defn success
  "Show a success toast (green check icon, auto-dismisses)."
  [label]
  (oops/ocall Toast "success" label))

(defn error
  "Show an error toast (red icon, auto-dismisses)."
  [label]
  (oops/ocall Toast "error" label))

(defn toaster
  []
  (let []
    [react-hot-toast-toaster
     {:containerStyle {:z-index "100000"}
      :toastOptions   {:style   {:border-radius "4px"}
                       :success {:duration  3000
                                 :iconTheme {:primary "#8ABF4C"}}}}]))
